import styled from 'styled-components';
import { Button } from '@/ui';
export const StudioButton = styled(Button).attrs((props) => ({
  variant: props.variant ?? 'secondary',
}))`
  &[aria-pressed='true'] {
    background: ${({ theme }) => theme.color.accentCyan}20;
    color: ${({ theme }) => theme.color.accentCyan};
  }
`;
export const Panel = styled.section`
  display: grid;
  gap: 16px;
  padding: 20px;
  min-width: 0;
  border: 1px solid ${({ theme }) => theme.color.hairSoft};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.surface};
  h3,
  h4,
  p {
    margin: 0;
  }
  p,
  small {
    line-height: 1.6;
  }
`;
export const Row = styled.div`
  &:empty {
    display: none;
  }
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;
export const Field = styled.label`
  display: grid;
  gap: 7px;
  min-width: 0;
  font-size: 14px;
  input,
  textarea,
  select {
    width: 100%;
    box-sizing: border-box;
    padding: 11px 12px;
    font: inherit;
    color: ${({ theme }) => theme.color.textPrimary};
    background: ${({ theme }) => theme.color.surfaceRaised};
    border: 1px solid ${({ theme }) => theme.color.hairSoft};
    border-radius: ${({ theme }) => theme.radius.md};
  }
  textarea {
    min-height: 100px;
    resize: vertical;
  }
  input:focus-visible,
  textarea:focus-visible,
  select:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
`;
export const Note = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.textMuted};
  font-size: 13px;
  line-height: 1.6;
`;
export const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px;
  overflow: hidden;
  position: relative;
  border: 1px solid ${({ theme }) => theme.color.hairSoft};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: linear-gradient(
    115deg,
    ${({ theme }) => theme.color.accentCyan}20,
    ${({ theme }) => theme.color.surface}
  );
  > svg {
    color: ${({ theme }) => theme.color.accentCyan};
    flex-shrink: 0;
  }
  strong {
    display: block;
    font-size: 19px;
    margin-bottom: 5px;
  }
  &::after {
    content: '';
    pointer-events: none;
    position: absolute;
    right: -75px;
    top: -100px;
    width: 300px;
    height: 300px;
    background: ${({ theme }) => theme.color.accentCyan}08;
    border-radius: 50%;
    box-shadow:
      0 0 0 22px ${({ theme }) => theme.color.accentCyan}06,
      0 0 0 52px ${({ theme }) => theme.color.accentCyan}06;
  }
`;

export const LiveWriting = styled.div`
  position: relative;
  textarea,
  [data-cursor-text] {
    font: inherit;
    line-height: 1.6;
    letter-spacing: normal;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    tab-size: 8;
  }
  textarea {
    display: block;
    min-height: 220px;
    resize: vertical;
    padding: 12px;
  }
`;
